export default {
  GALLERY_VIEW: 'gallery-view',
  LIST_VIEW: 'list-view',
};
